import { Grid, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useHistory } from 'react-router-dom';

import { useStyles } from "./styles";
import Triptych from 'components/triptych';
import Button from '../../components/button';

import CTAAdvertisementComponent from 'components/ctaComponent/CTAComponent';
import FAQComponent from 'components/FAQComponent/FAQComponent';
import CustomerFeedbackComponent from 'components/CustomerFeedbackComponent/CustomerFeedbackComponent';
import LoginImage from '../../assets/triptychImages/loginImage.jpg';
import Viewmage from '../../assets/triptychImages/viewImages.jpg';
import ShareImage from '../../assets/triptychImages/shareImage.jpg';

const Home = () => {
    const classes = useStyles();
    const history = useHistory();

    const triptychList = [
        {
            header: 'Login',
            image:  LoginImage,
            text: 'Login to your account using the username/password provided during your last Ultrasound scan.'
        },
        {
            header: 'View Your Images',
            image:  Viewmage,
            text: 'Once logged in, you can view the images selected by your sonographer or physician.'
        },
        {
            header: 'Download / Share',
            image:  ShareImage,
            text: 'Select the images you want to download or share them directly to social media. Come back after your next visit.'
        }
    ];

    return (
        <Grid container className={classes.homeWrapper}>
            <Grid container className={classes.mainFeatured}>
                 <Grid item md={6} className={classes.mainFeaturedContent}>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.bannerHeader}>
                        Welcome to MommyVue
                    </Typography>
                    <Typography variant="body2" color="inherit" style={{ color: "black", fontSize: "14px", lineHeight: "60px" }} paragraph>
                        The simplicity of medical imaging, everywhere
                    </Typography>
                    <Button
                        text={'Patient/Clinician Login'}
                        icon={<ArrowForwardIcon/>}
                        action={() => {
                            history.push('/login')
                        }}
                    />
                    {/* <Button
                        text={'Client Signup'}
                        version={'secondary'}
                        icon={<ArrowForwardIcon/>}
                        action={() => {
                            history.push('/signup')
                        }}
                    /> */}
                </Grid>
            </Grid>
            <Grid container className={classes.howItWorks}>
                <div id='how-it-works' className={classes.howItWorksHook}></div>
                <Typography
                    component="h1"
                    variant="h5"
                    color="inherit"
                    gutterBottom          
                    style={{
                        color: "black", 
                        fontSize: "35px", 
                        lineHeight: "50px",
                        width: '100%',
                        textAlign: 'center'
                }}>
                    How It Works
                </Typography>
                <Typography variant="body2" color="inherit" style={{
                    color: "black",
                    fontSize: "14px",
                    width: '1000px',
                    margin: '0 auto',
                    textAlign: 'center'
                }} paragraph>
                    Share images, clips and reports with the push of a button directly on your imaging or from the MommyVue App. Your 
                    patients can then share them with family and friends.
                </Typography>
                <Triptych triptychList={triptychList}/>
            </Grid>
            <CTAAdvertisementComponent />
            <CustomerFeedbackComponent />
            <FAQComponent />
        </Grid>
    );
}

export default Home
